/**
 * Predicado puro de "¿conviene avisar antes de mandarle este documento a alguien?" (TKT-2182).
 *
 * Vive fuera del store a propósito: así el test ejercita EXACTAMENTE el código que corre en
 * producción, en vez de un espejo que se puede desincronizar en silencio (mismo patrón que el resto
 * de la suite offline-v2, que importa el código real).
 */

/**
 * ¿La auditoría que se va a enviar está SIN FINALIZAR?
 *
 * Es el caso dominante en producción: el auditor la contesta completa y la comparte por correo sin
 * presionar FINALIZAR (medido: 79/79 respuestas y el cierre 17 h después). No es un problema de
 * sincronización — no hay ningún cierre encolado que esperar — pero al destinatario le llega el PDF
 * con "Sin Finalizar" y sin calificación.
 *
 * Sólo afirma que está sin finalizar cuando hay CERTEZA: la occurrence cargada es la misma que se va
 * a enviar y viene marcada como abierta. Ante cualquier duda devuelve false, para no meterle un
 * diálogo de más al usuario en el camino normal.
 *
 * Se acepta el `0` numérico además del `false`: hoy el accessor del backend devuelve un bool real,
 * pero `current` podría hidratarse algún día desde SQLite, donde los booleanos viven como 0/1. Es la
 * misma defensa que ya trae pending-close.js para el caso contrario (`is_closed === 1`).
 *
 * @param {object|null} current       occurrence cargada en el store
 * @param {number|string} occurrenceId  la que se va a enviar
 * @returns {boolean}
 */
export const looksUnfinished = (current, occurrenceId) => {
  if (!current || String(current.id) !== String(occurrenceId)) return false
  return current.is_closed === false || current.is_closed === 0
}

/**
 * ¿Hay que pedirle confirmación al usuario antes de mandar el documento?
 *
 * `hadPending` = se acaba de esperar un cierre encolado y ya llegó al server, así que la auditoría SÍ
 * quedó finalizada aunque `current.is_closed` en memoria siga desactualizado. Sin esa distinción el
 * aviso saltaba en el camino de todos los días (finalizar y mandar por correo), que es justo cuando
 * NO debe salir.
 *
 * @param {{ hadPending: boolean, current: object|null, occurrenceId: number|string }} args
 * @returns {boolean}
 */
export const shouldConfirmUnfinished = ({ hadPending, current, occurrenceId }) =>
  !hadPending && looksUnfinished(current, occurrenceId)
